import { HttpErrorResponse } from '@angular/common/http';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';

import { Component, Inject, Output, EventEmitter } from '@angular/core';
import { NotificationsServiceInterface } from '../../../../core/services/notifications/notifications-service.interface';
import { ResetPasswordServiceInterface } from '../../services/reset-password/reset-password-service.interface';
import { errorTextBuilder } from '../../../../core/helpers/error-text-builder.function';

@Component({
  selector: 'gtd-reset-password-component',
  templateUrl: './reset-password.component.html',
})
export class ResetPasswordComponent {
  @Output() back: EventEmitter<string> = new EventEmitter();
  @Output() resetEmail: EventEmitter<string> = new EventEmitter();
  @Output() resetConfirm: EventEmitter<string> = new EventEmitter();

  public isEmailConfirm = false;
  public isPasswordChanged = false;
  public errorTextBuilder = errorTextBuilder;
  public form = new UntypedFormGroup({
    email: new UntypedFormControl(null, [Validators.required, Validators.email]),
    code: new UntypedFormControl(null, [Validators.required, Validators.minLength(4)]),
    password: new UntypedFormControl(null, Validators.required),
    password_confirmation: new UntypedFormControl(null, Validators.required),
  });

  constructor(
    @Inject('ResetPasswordServiceInterface') public resetPasswordService: ResetPasswordServiceInterface,
    @Inject('NotificationsServiceInterface') public notificationsService: NotificationsServiceInterface
  ) {}

  get email(): UntypedFormControl {
    return this.form.get('email') as UntypedFormControl;
  }

  get code(): UntypedFormControl {
    return this.form.get('code') as UntypedFormControl;
  }

  get password(): UntypedFormControl {
    return this.form.get('password') as UntypedFormControl;
  }

  get passwordConfirm(): UntypedFormControl {
    return this.form.get('password_confirmation') as UntypedFormControl;
  }

  backToAuthPage(): void {
    this.back.emit();
  }

  backToEmail(): void {
    this.isEmailConfirm = !this.isEmailConfirm;
    this.isPasswordChanged = !this.isPasswordChanged;
    this.resetEmail.emit();
  }

  confirmEmail(): void {
    this.resetPasswordService.confirmEmail(this.email.value).subscribe(
      () => {
        this.notificationsService.add({
          title: 'The code has been sent to your email address.',
          type: 'success',
        });

        this.isEmailConfirm = true;
        this.resetEmail.emit();
      },
      (error: HttpErrorResponse) => {
        if (error.error.errors) {
          for (const key in error.error.errors) {
            if (error.error.errors.hasOwnProperty(key)) {
              this.notificationsService.add({
                type: 'error',
                title: error.error.errors[key],
              });
            }
          }
        } else if (error.error.error) {
          this.notificationsService.add({
            type: 'error',
            title: error.error.error,
          });
        }
      }
    );
  }

  resetPassword(): void {
    this.resetPasswordService.reset(this.form.getRawValue()).subscribe(
      () => {
        this.notificationsService.add({
          title: 'Your password was changed.',
          type: 'success',
        });

        this.isPasswordChanged = true;
        this.resetConfirm.emit();
      },
      (error: HttpErrorResponse) => {
        if (error.error.errors) {
          for (const key in error.error.errors) {
            if (error.error.errors.hasOwnProperty(key)) {
              this.notificationsService.add({
                type: 'error',
                title: error.error.errors[key],
              });
            }
          }
        } else if (error.error.error) {
          this.notificationsService.add({
            type: 'error',
            title: error.error.error,
          });
        }
      }
    );
  }
}
